import { useMemo } from 'react';
import { Size } from 'types';
import { getCaptionsPositionStyle, Style } from 'utils/embed/captions';

type UseEditSceneCaptionsStyleResult = {
  captionsPositionStyle: React.CSSProperties | undefined;
};

export default function useEditSceneCaptionsStyle(
  captionsStyle: Style | undefined,
  previewDimensions: Size<number> | undefined,
): UseEditSceneCaptionsStyleResult {
  const captionsPositionStyle = useMemo(() => {
    if (!captionsStyle || !previewDimensions) return undefined;
    return getCaptionsPositionStyle(captionsStyle, previewDimensions);
  }, [captionsStyle, previewDimensions]);

  return {
    captionsPositionStyle,
  };
}
